const PBDReducer = (state = {}, action) => {
    switch (action.type) {
        case "PBDLIST_DOCS":
            return Object.assign({}, state, {
                PBD_ListView: action.data
            });
        case "LOOKUP_PBDDESC":
            return Object.assign({}, state, {
                PBDDESC_LOOKUP: action.data
            });
        case "PBDEDIT_DOCS":
            return Object.assign({}, state, {
                geteditpbd: action.data
            });
        case "SHARE_PBDFILES":
            return Object.assign({}, state, {
                sharedpbdfile: action.data
            });
        case "SHARE_PBDDATAS":
            return Object.assign({}, state, {
                sharedpbddata: action.data
            });
        case "ERROR_PBDFILES":
            return Object.assign({}, state, {
                errorpbdpass: action.data
            });
        case "PASS_PBDOTHERS":
            return Object.assign({}, state, {
                otherspbdpass: action.data
            });
        default:
            return state;
    }
};

export default PBDReducer;